import { render } from "./ManagerNavbar.vue?vue&type=template&id=42a68a56"
import script from "./ManagerNavbar.vue?vue&type=script&lang=js"
export * from "./ManagerNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__